import { render, staticRenderFns } from "./WalletFamily.vue?vue&type=template&id=410cfecf"
import script from "./WalletFamily.vue?vue&type=script&lang=js"
export * from "./WalletFamily.vue?vue&type=script&lang=js"
import style0 from "./WalletFamily.vue?vue&type=style&index=0&id=410cfecf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports